<template>
  <Badge :variant="badgeVariant">{{ stage }}</Badge>
</template>

<script>
import { Badge } from '@/components/ui/badge';

export default {
  components: {
    Badge,
  },
  props: {
    stage: {
      type: String,
      required: true,
    },
  },
  computed: {
    badgeVariant() {
      switch (this.stage) {
        case 'Hired':
          return 'green';
        case 'Disqualified':
        case 'Unlicensed':
          return 'red';
        default:
          return 'yellow';
      }
    },
  },
};
</script>
